import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";

import CustomerBalanceApi from "../../../../../infrastructure/api/customerBalance";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import PanelBalanceCard from "../../../../components/payment-gateway/PanelBalanceCard";
import { formatRial, pick } from "../../../../components/payment-gateway/paymentGatewayUtils";
import { parseAmountInput } from "../../../../components/request/case-tabs/financialCoreUtils";

const QUICK_AMOUNTS = [
  { label: "۵۰۰ هزار ریال", value: 500_000 },
  { label: "۱ میلیون ریال", value: 1_000_000 },
  { label: "۵ میلیون ریال", value: 5_000_000 },
];

const CustomerBalanceTopUpPage = () => {
  const [amount, setAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleStart = async () => {
    const value = parseAmountInput(amount);
    if (!value || value <= 0) {
      toast.warning("مبلغ افزایش اعتبار را وارد کنید.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await CustomerBalanceApi.startTopUp(value);
      if (res?.isSuccess === false) {
        toast.error(res?.message || "شروع پرداخت ناموفق بود.");
        return;
      }
      const data = res?.data ?? res?.Data;
      const redirectUrl = pick(data, "redirectUrl", "RedirectUrl");
      if (!redirectUrl) {
        toast.error("آدرس درگاه دریافت نشد.");
        return;
      }
      window.location.href = redirectUrl;
    } catch {
      toast.error("خطا در اتصال به درگاه پرداخت");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={8} lg={5} sx={{ mx: "auto" }}>
        <Stack spacing={2}>
          <PanelBalanceCard compact showHistoryLink />

          <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
            <Stack spacing={2}>
              <Typography variant="h6" fontWeight={600}>
                افزایش اعتبار
              </Typography>
              <Alert severity="info">
                پس از پرداخت موفق، مبلغ به اعتبار پنل شما اضافه می‌شود.
              </Alert>

              <TextField
                label="مبلغ (ریال)"
                size="small"
                fullWidth
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />

              <Stack direction="row" flexWrap="wrap" sx={{ gap: 1 }}>
                {QUICK_AMOUNTS.map((item) => (
                  <Button
                    key={item.value}
                    size="small"
                    variant="outlined"
                    onClick={() => setAmount(String(item.value))}
                  >
                    {item.label}
                  </Button>
                ))}
              </Stack>

              <Button
                variant="contained"
                size="large"
                disabled={submitting}
                onClick={handleStart}
              >
                {submitting ? "در حال اتصال…" : "پرداخت و افزایش اعتبار"}
              </Button>
            </Stack>
          </Paper>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CustomerBalanceTopUpPage;
